var _rect, _rect2, _rect3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    width: 140,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 36.4,
    fill: "#0D194A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 80,
    width: 22,
    height: 46,
    rx: 3.96,
    fill: "#4BB8C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 48,
    width: 22,
    height: 78,
    rx: 3.96,
    fill: "#F87433"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 28,
    r: 12.98,
    fill: "#FFDB5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistIcon);
export default __webpack_public_path__ + "static/media/assistIcon.66a5ca737b153206d8fd1b29cbe037b8.svg";
export { ForwardRef as ReactComponent };